<template>
	<div class="main" id="print_popup">
		<div class="modal fade in show" tabindex="-1" role="dialog" style="display: block;">
			<div class="modal-dialog modal-dialog-scrollable">
				<div class="modal-content">
					<div class="modal-header">
						<span class="modal-title">預覽列印</span>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closePopup()">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
                        <div id="div5" class="body-by-A4">
                            <h3 style="text-align: center;">亞東科技大學{{$parent.weakApply.year}}學年度大專校院弱勢學生助學計畫(助學金)申請表</h3>
                            <table class="table table-no-more table-bordered table-striped mb-none">
                                <tbody>
                                    <tr>
                                        <td data-title="姓名" class="text-left" width="4%">姓名</td>
                                        <td data-title="姓名" class="text-left" width="6%">{{$parent.stu.name}}</td>
                                        <td data-title="學號" class="text-left" width="4%">學號</td>
                                        <td data-title="學號" class="text-left" width="6%">{{$parent.stu.account}}</td>
                                        <td data-title="身分證字號" class="text-left" width="4%">身分證字號</td>
                                        <td data-title="身分證字號" class="text-left" width="6%">{{$parent.stu.idno}}</td>
                                    </tr>
                                    <tr>
                                        <td data-title="學制" class="text-left" width="4%">學制</td>
                                        <td data-title="學制" class="text-left" width="6%">
                                            {{$parent.ssymList.some(ssym => ssym.commCode == $parent.stu.ssym) ?
                                            $parent.ssymList.filter(ssym => ssym.commCode == $parent.stu.ssym)[0].commValue :
                                            ''}}
                                        </td>
                                        <td data-title="系科班級" class="text-left" width="4%">系級</td>
                                        <td data-title="系科班級" class="text-left" width="6%">
                                            {{$parent.deptList.some(dept => dept.commCode == $parent.stu.dept) ?
                                            $parent.deptList.filter(dept => dept.commCode == $parent.stu.dept)[0].commValue :
                                            ''}}
                                            {{$parent.dradeList.some(drade => drade.key == $parent.stu.drade) ?
                                            $parent.dradeList.filter(drade => drade.key == $parent.stu.drade)[0].value :
                                            ''}}
                                            {{$parent.dradeClassList.some(dradeClass => dradeClass.key == $parent.stu.dradeClass) ?
                                            $parent.dradeClassList.filter(dradeClass => dradeClass.key == $parent.stu.dradeClass)[0].value :
                                            ''}}
                                        </td>
                                        <td data-title="聯絡電話" class="text-left" width="4%">聯絡電話</td>
                                        <td data-title="聯絡電話" class="text-left" width="6%">{{$parent.stu.phone}}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <table class="table table-no-more table-bordered table-striped mb-none">
                                <tbody>
                                    <tr>
                                        <td data-title="申請類別(請勾選)" style="text-align: center;">申請資格(需同時符合)</td>
                                        <td data-title="應繳證明文件" style="text-align: center;">應繳證明文件
                                        </td>
                                    </tr>
                                    <tr>
                                        <td data-title="申請資格(需同時符合)" class="text-left">
                                            1.學士班:家庭年所得低於90萬元，碩士班:家庭年所得低於70萬元。<br>2.家庭應計列人口之利息所得合計低於2萬元。<br>3.家庭應計列人口合計擁有不動產價值低於650萬元。<br>4.前一學期學業成績平均60分以上。(新生、轉學生除外)
                                        </td>
                                        <td data-title="應繳證明文件" class="text-left"><input type="checkbox"
                                                checked disabled>戶籍謄本正本(3個月內，含詳細記事)或新式戶口名簿影本(直式橫書，含詳細記事)<br><br>注意：<br>家庭所得計列範圍，及戶籍謄本或戶口名簿所需之家庭成員如下：<br>1.未婚學生：學生本人、學生父母。<br>2.已婚學生：學生本人及配偶。<br>3.學生離婚或配偶死亡：學生本人。
                                        </td>
                                    </tr>
                                    <tr>
                                        <td data-title="上學期學業成績" class="text-left" colspan="2">前一學期學業成績： {{$parent.weakApply.lastSmtrScore}}
                                            分 　　　　　　　
                                            <input type="checkbox" :checked="$parent.weakApply.lastSmtrType == '1'" disabled>新生免計成績　　　　　　　
                                            <input type="checkbox" :checked="$parent.weakApply.lastSmtrType == '2'" disabled>轉學生免計成績
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <table class="table table-no-more table-bordered table-striped mb-none">
                                <tbody>
                                    <tr>
                                        <td data-title="稱謂" style="text-align: center;" width="3%">稱謂</td>
                                        <td data-title="姓名" style="text-align: center;" width="5%">姓名</td>
                                        <td data-title="身分證字號" style="text-align: center;" width="5%">身分證字號</td>
                                        <td data-title="職業" style="text-align: center;" width="5%">職業</td>
                                    </tr>
                                    <tr>
                                        <td data-title="家長" style="text-align: center;" width="3%">
                                            {{$parent.weakKinshipList.some(weakKinship => weakKinship.commCode == $parent.weakApply.kinshipList[0].kinshipType) ?
                                            $parent.weakKinshipList.filter(weakKinship => weakKinship.commCode == $parent.weakApply.kinshipList[0].kinshipType)[0].commValue :
                                            ''}}
                                        </td>
                                        <td data-title="簽名" style="text-align: center;" width="5%">
                                            {{$parent.weakApply.kinshipList[0].status == 'P' ? '歿' : $parent.weakApply.kinshipList[0].status == 'O' ? '無' :  $parent.weakApply.kinshipList[0].name}}
                                        </td>
                                        <td data-title="身分證字號" style="text-align: center;" width="3%">
                                            {{$parent.weakApply.kinshipList[0].status == 'P' || $parent.weakApply.kinshipList[0].status == 'O'? '' : $parent.weakApply.kinshipList[0].idNo}}
                                        </td>
                                        <td data-title="職業" style="text-align: center;" width="5%">
                                            {{$parent.weakApply.kinshipList[0].status == 'P' || $parent.weakApply.kinshipList[0].status == 'O'? '' :
                                            $parent.weakKinshipOccupationList.some(o => o.commCode == $parent.weakApply.kinshipList[0].occupationType) ?
                                            $parent.weakKinshipOccupationList.filter(o => o.commCode == $parent.weakApply.kinshipList[0].occupationType)[0].commCode == 'O' ?
                                             $parent.weakApply.kinshipList[0].occupationValue :
                                             $parent.weakKinshipOccupationList.filter(o => o.commCode == $parent.weakApply.kinshipList[0].occupationType)[0].commValue :
                                            ''}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td data-title="家長" style="text-align: center;" width="3%">
                                            {{$parent.weakKinshipList.some(weakKinship => weakKinship.commCode == $parent.weakApply.kinshipList[1].kinshipType) ?
                                            $parent.weakKinshipList.filter(weakKinship => weakKinship.commCode == $parent.weakApply.kinshipList[1].kinshipType)[0].commValue :
                                            '　'}}
                                        </td>
                                        <td data-title="簽名" style="text-align: center;" width="5%">
                                            {{$parent.weakApply.kinshipList[1].status == 'P' ? '歿' : $parent.weakApply.kinshipList[1].status == 'O' ? '無' : $parent.weakApply.kinshipList[1].name}}
                                        </td>
                                        <td data-title="蓋章" style="text-align: center;" width="3%">
                                            {{$parent.weakApply.kinshipList[1].status == 'P' || $parent.weakApply.kinshipList[1].status == 'O'? '' : $parent.weakApply.kinshipList[1].idNo}}
                                        </td>
                                        <td data-title="身分證字號" style="text-align: center;" width="5%">
                                            {{$parent.weakApply.kinshipList[1].status == 'P' || $parent.weakApply.kinshipList[1].status == 'O'? '' :
                                            $parent.weakKinshipOccupationList.some(o => o.commCode == $parent.weakApply.kinshipList[1].occupationType) ?
                                            $parent.weakKinshipOccupationList.filter(o => o.commCode == $parent.weakApply.kinshipList[1].occupationType)[0].commCode == 'O' ?
                                             $parent.weakApply.kinshipList[1].occupationValue :
                                             $parent.weakKinshipOccupationList.filter(o => o.commCode == $parent.weakApply.kinshipList[1].occupationType)[0].commValue :
                                            ''}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td data-title="注意事項" class="text-left" colspan="8">
                                            注意事項：<br>1.弱勢助學金資格審查由教育部轉財政部查核，約於每年11月20日左右公告查核結果，如對查核結果有疑義，應依限(另公告之)檢附佐證資料修正。<br>2.家庭利息所得自優惠存款且存款本金未逾100萬元者，得檢附相關佐證資料，由學校審核認定，並報部備查。<br>3.弱勢助學金補助金額於下學期繳費單內扣除，進修部學生該學年度實際繳納之學雜費用如低於補助標準，僅得補助該學年度實際繳內數額，如無法全數扣除者另退費之。<br>4.已申請各類學雜費減免，及政府其他助學措施者，不得再申請本助學金。
                                            <br>
                                            <br>
                                            <div style="display: flex; justify-content: right">
                                              <div style="height: 50px;display: flex;">
                                                <span style="align-self: flex-end;">
                                                  我已瞭解上述說明事項：學生_____________________
                                                </span>
                                              </div>
                                              <div class="square">
                                                <span style="align-self: center">
                                                  蓋章
                                                </span>
                                              </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
					</div>
					<div class="modal-footer">
                        <span style="font-size: 20px;font-weight: bold">請將此申請書列印並簽名後，以拍照或掃描的方式上傳檔案至申請書欄位。</span>
						<button type="button" class="btn btn-primary" @click="handlePrint">列印</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Printd } from 'printd'
export default {
    mounted(){
	},
	data(){
		return {
		}
	},
	methods:{
		handlePrint() {
			const d = new Printd();
			d.print(document.getElementById('div5'),[`
				.body-by-A4 p{line-height:1;}
				.body-by-A4 .table-bordered{border-collapse: collapse; border: 1px solid #ddd;}
				.body-by-A4 .table-bordered tr>td{ padding: 0; line-height: 1.5; vertical-align: top; border: 1px solid #ddd;  }
                .s_right { text-align: right; display: block;}
                hr.no-soild { height: 0; border-bottom: 1px solid #666666; margin: 8px 0px 0px 0px;}
                .table-striped>tbody>tr:nth-of-type(odd) {background-color: #f9f9f9;}
        .square { width: 50px; height: 50px; border: #000000 1px solid; display: flex;justify-content: center;}
			`])
            this.$parent.showPrintPopup(false);
            this.$parent.isShowPrintBtn = false;
            bootbox.alert("以拍照或掃描的方式上傳檔案至申請書欄位並送出，才算完成申請。\n若無法當下完成申請書上傳可透過弱勢助學金申請查詢功能，完成最後上傳步驟。");
		},
		closePopup() {
			this.$parent.showPrintPopup(false);
		}
	}
}
</script>
<style>
@media (min-width: 768px){
  #print_popup .modal-dialog {
    width: 720px;
    margin: 30px auto;
  }
}

@media (min-width: 992px){
  #print_popup .modal-dialog {
    width: 880px;
    margin: 30px auto;
  }
}

@media (min-width: 1200px){
  #print_popup .modal-dialog {
    width: 1200px;
    margin: 30px auto;
  }
}

#print_popup .modal-dialog-scrollable {
  height: calc(100% - (30px + 5px));
}

#print_popup .modal-dialog-scrollable .modal-content {
  display: grid;
  height: 100%;
  overflow: hidden;
}

#print_popup .modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.s_right {
    text-align: right;
    display: block;
}

hr.no-soild {
    height: 0;
    border-bottom: 1px solid #666666;
    margin: 8px 0px 0px 0px;
}
.square {
  width: 50px;
  height: 50px;
  border: #000000 1px solid;
  display: flex;
  justify-content: center;
}

@media screen {
  #print {
    display: none;
   }
}

@media print {
 body * {
  visibility:hidden;
  }
  #print, #print * {
    visibility:visible;
  }
  #print {
    position:absolute;
    left:0;
    top:0;
  }
}
</style>
